import { render } from "./limit-tooltip.vue?vue&type=template&id=15c963aa&ts=true"
import script from "./limit-tooltip.vue?vue&type=script&lang=ts"
export * from "./limit-tooltip.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__